import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-yoga-cream">
      {/* Header */}
      <header className="bg-yoga-cream border-b border-yoga-sand">
        <div className="max-w-4xl mx-auto px-6 py-6">
          <Link to="/" className="inline-flex items-center gap-2 text-yoga-brown hover:text-yoga-sage transition-colors">
            <ArrowLeft size={20} strokeWidth={1.5} />
            <span className="font-sans">Zurück zur Startseite</span>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="font-serif text-4xl text-yoga-brown mb-8">Impressum</h1>

        <div className="space-y-8 font-sans text-yoga-brown/80 leading-relaxed">
          <section>
            <h2 className="font-serif text-2xl text-yoga-brown mb-4">Angaben gemäß § 5 TMG</h2>
            <p>
              Daniela Kizay<br />
              Bungertweg 8<br />
              50226 Frechen
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-yoga-brown mb-4">Kontakt</h2>
            <p>
              Telefon: +49 (0) 177 8117539<br />
              E-Mail: info@danielakizay.de
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-yoga-brown mb-4">Umsatzsteuer-ID</h2>
            <p>
              Gemäß § 19 UStG wird keine Umsatzsteuer berechnet (Kleinunternehmerregelung).
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-yoga-brown mb-4">Berufsbezeichnung und berufsrechtliche Regelungen</h2>
            <p>
              Berufsbezeichnung: Yogalehrerin<br />
              Zuständige Kammer: Keine Kammerzugehörigkeit erforderlich<br />
              Verliehen in: Deutschland
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-yoga-brown mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p>
              Daniela Kizay<br />
              Bungertweg 8<br />
              50226 Frechen
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-yoga-brown mb-4">EU-Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
              <a 
                href="https://ec.europa.eu/consumers/odr/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-yoga-sage hover:underline"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p className="mt-2">
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-yoga-brown mb-4">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-yoga-brown mb-4">Haftung für Inhalte</h2>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="mt-4">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-yoga-brown mb-4">Haftung für Links</h2>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
            </p>
            <p className="mt-4">
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-yoga-brown mb-4">Urheberrecht</h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
            </p>
            <p className="mt-4">
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-yoga-brown text-yoga-cream py-8 mt-12">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="font-sans text-sm text-yoga-cream/70">
            © {new Date().getFullYear()} DanyKizayYoga
          </p>
        </div>
      </footer>
    </div>
  );
};

export default ImpressumPage;
